// React Hook Form consts
export const mode = 'all';
export const reValidateMode = 'onChange';

export const STEP_1 = 'splash';
export const STEP_HOUSEHOLD = 'household';
export const STEP_DELIVERY = 'deliveryDay';
export const STEP_DIET = 'diet';
